import React from 'react';
import trilogyOneLogo from '../assets/trilogy-one-logo.png';
import './AppBrandMark.css';

const SIZE_CLASS = {
  header: 'app-brand-mark--header',
  login: 'app-brand-mark--login',
  compact: 'app-brand-mark--compact',
};

/**
 * Trilogy One care app logo.
 * Height is capped so it fits the header and login title areas; width follows aspect ratio.
 */
export default function AppBrandMark({ className = '', size = 'header', as: Component = 'span', ...rest }) {
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.header;
  const combined = ['app-brand-mark', sizeClass, className].filter(Boolean).join(' ');
  return (
    <Component className={combined} aria-label="Trilogy One" {...rest}>
      <img
        src={trilogyOneLogo}
        alt=""
        className="app-brand-mark__img"
        decoding="async"
      />
    </Component>
  );
}
